import SelectRow from '@dc-shared-web/components/features/AIConfigDialog/SelectRow'
import { CONTEXT_MODES } from '@dc-shared-web/components/features/AIConfigDialog/constants'
import { AIConfigModalValues } from '@dc-shared-web/components/features/AIConfigDialog/types'

const ContextModeRow = ({
  values,
  disabled,
  mode_map,
  onChange,
}: {
  values: AIConfigModalValues
  disabled?: boolean
  mode_map?: string[]
  onChange: (values: AIConfigModalValues) => void
}) => {
  const handleChange = (value: string) => {
    onChange({ ...values, contextMode: value })
  }

  let modes = CONTEXT_MODES
  if (mode_map) {
    modes = modes.filter((mode) => mode_map.includes(mode.value))
  }

  return (
    <SelectRow
      label='Context mode'
      value={values.contextMode}
      options={modes}
      onChange={handleChange}
      disabled={disabled}
    />
  )
}

export default ContextModeRow
